import { useSpaceDetail } from '@confluence/space-utils/entry-points/useSpaceDetail';

export const useSpaceType = ({ spaceKey }) => {
	const { data: spaceData } = useSpaceDetail(spaceKey);

	return { spaceType: spaceData?.type, isKnowledgeBaseSpace: spaceData?.type === 'knowledge_base' };
};
